import { render, staticRenderFns } from "./ricercaGaranzieWondersafe.vue?vue&type=template&id=678fa68b&"
import script from "./ricercaGaranzieWondersafe.vue.ts?vue&type=script&lang=ts&"
export * from "./ricercaGaranzieWondersafe.vue.ts?vue&type=script&lang=ts&"
import style0 from "./ricercaGaranzieWondersafe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports